import React, { useContext, useState, useEffect } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  FormControl,
  Row,
  Tab,
  Tabs,
} from "react-bootstrap";
import DocumentMeta from "react-document-meta";
import renderHtml from "react-render-html";
import Modal from "../Components/Modal";
import Pagination from "../Components/Pagination";
import Config from "../config.json";
import { IoMdDownload } from "react-icons/io";
import Loading from "./Loading";
import ComponentContext from "../Context";
import Shive from "../Images/csl.webp";
import { useHash } from "../lib/hooks";
import Statics from "../Statics";

const page_meta = {
  language: "fa",
  copyright: "پژوهیار",
  description: "نرم‌افزار استناددهی",
  title: Config.title + " | شیوه‌نامه",
  meta: {
    charset: "utf-8",
    name: {
      keywords: "پژوهیار",
    },
  },
};

const ACCEPTABLE_HASHES = ["csl-list", "csl-order"];

const Csl = () => {
  const { ApiDriver } = useContext(ComponentContext);
  const context = useContext(ComponentContext);
  const [form_name, set_form_name] = useState("");
  const [form_email, set_form_email] = useState("");
  const [form_phone, set_form_phone] = useState("");
  const [form_head, set_form_head] = useState("");
  const [form_headphone, set_form_headphone] = useState("");
  const [form_organization, set_form_organization] = useState("");
  const [form_faculty, set_form_faculty] = useState("");
  const [form_website, set_form_website] = useState("");
  const [form_description, set_form_description] = useState("");
  const [form_file, set_form_file] = useState("");
  const [send_order, set_send_order] = useState(false);
  const [base, set_base] = useState("0");
  const [base_csl, set_base_csl] = useState([]);
  const [errors, setErrors] = useState({
    name: "",
    email: "",
    phone: "",
  });
  const [loadingState, setLoadingState] = useState(Statics.NOT_LOADED);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(12);
  const [csls, setCsls] = useState([]);
  const [sources, setSources] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchSource, setSearchSource] = useState("");
  const [searchCslType, setSearchCslType] = useState("");
  const [filteredCsls, setFilteredCsls] = useState([]);

  const selectedTab = useHash(ACCEPTABLE_HASHES);
  const validateForm = () => {
    let newErrors = {};
    let isValid = true;

    if (!form_name.trim()) {
      newErrors.name = "نام و نام خانوادگی الزامی است";
      isValid = false;
    }

    if (!form_email.trim()) {
      newErrors.email = "آدرس ایمیل الزامی است";
      // isValid = false;
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(form_email)) {
      newErrors.email = "فرمت ایمیل نامعتبر است";
      isValid = false;
    }

    if (!form_phone.trim()) {
      newErrors.phone = "شماره تماس الزامی است";
      isValid = false;
    } else if (!/^09\d{9}$/.test(form_phone)) {
      newErrors.phone = "فرمت شماره تماس نامعتبر (مثال: 09123456789)";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const SendOrder = () => {
    if (!validateForm()) return;
    const formData = {};
    formData.fullname = form_name;
    formData.phone = form_phone;
    formData.email = form_email;
    formData.description = form_description;
    formData.head_fullname = form_head;
    formData.head_phone = form_headphone;
    formData.organization = form_organization;
    formData.faculty = form_faculty;
    formData.website = form_website;
    formData.file = form_file;
    formData.base = base.toString();
    set_send_order(true);
    ApiDriver.sendCslOrder(
      formData,
      (data, meta) => {
        set_send_order(false);
        context.notification("سفارش با موفقیت ثبت شد", "success");
      },
      error => {
        context.notification("مشکلی در ارسال بوجود آمد.", "error");
        set_send_order(false);
        if (error.response?.data?.errors) {
          const serverErrors = error.response.data.errors.reduce((acc, err) => {
            acc[err.field] = err.message;
            return acc;
          }, {});
          setErrors(serverErrors);
        }
      },
    );
  };

  const generateExample = (id, title) => {
    context.modal.show();
    context.ApiDriver.generateCitationBoth(
      {
        csl_id: id,
        data: [
          {
            id: "https://pajoohyar.ir/users/6/items/APJQ3GEI",
            type: "book",
            title: "آیین نگارش علمی",
            publisher: "هیات امنای کتابخانه های عمومی کشور",
            "publisher-place": "تهران",
            edition: "۳",
            "event-place": "تهران",
            language: "fa",
            numOfCreators: "5",
            author: [
              {
                family: "احمدی",
                given: "محمد",
              },
              {
                family: "حری",
                given: "عباس",
              },
              {
                family: "ناصری",
                given: "علی",
              },
              {
                family: "شوشتری",
                given: "مرتضی",
              },
              {
                family: "صادقی",
                given: "مسعود",
              },
            ],
            issued: {
              "date-parts": [["1381"]],
            },
          },
          {
            id: "https://pajoohyar.ir/users/6/items/F72RTMB2",
            type: "thesis",
            title: "بررسی مسائل خدمات اینترنتی",
            publisher: "تهران",
            "publisher-place": "تهران",
            "number-of-pages": "۱۲۵",
            genre: "کارشناسی ارشد حقوق جزا و جرمشناسی",
            "event-place": "تهران",
            URL: "WWW.GOOGLE.COM",
            "call-number": "۱۲۵۶۹",
            language: "fa",
            numPages: "۱۲۵",
            author: [
              {
                family: "معصومی",
                given: "مهدی",
              },
            ],
            counsel: [
              {
                family: "محمودی",
                given: "سمیرا",
              },
            ],
            "supervisor-thesis": [
              {
                family: "اکرمی",
                given: "ژیلا",
              },
            ],
            issued: {
              "date-parts": [["1383"]],
            },
          },
          {
            id: "https://pajoohyar.ir/users/6/items/NGTAJR3R",
            type: "book",
            title: "سیاست جنایی مشارکتی",
            publisher: "میزان",
            "publisher-place": "تهران",
            volume: "۲",
            "event-place": "تهران",
            ISBN: "978-964-511-264-4",
            language: "fa",
            author: [
              {
                family: "ملکی",
                given: "علی",
              },
            ],
            translator: [
              {
                family: "جمشیدی",
                given: "ناصر",
              },
            ],
            issued: {
              "date-parts": [["1390"]],
            },
          },
          {
            id: "https://pajoohyar.ir/users/6/items/WMKGRRUS",
            type: "article-journal",
            title:
              "ارزیابی راهکار‌های کاهش شوری آب رودخانه کارون با استفاده از سناریو‌های مدیریتی",
            "container-title": "دانشگاه صنعتی امیرکبیر",
            page: "245-256",
            issue: "2",
            source: "Sinaweb",
            abstract:
              "رودخانه کارون بزرگترین و طولانیترین رودخانه ایران است که در سالهای اخیر بارگذاری منابع آلاینده موجب افزایش شوری آب رودخانه شده است. هدف از این تحقیق، بررسی راهکارهای مدیریتی برای کاهش شوری رودخانه بصورت  سناریوهای حذف و کاهش بارگذاری منابع آلاینده نقطهای در محدوده ملاثانی تا فارسیات (مهمترین بازه تراکم جمعیتی، صنعتی و کشاورزی) با مدل MIKE11است. نتایج سناریوی حذف منابع آلاینده نشان داد، حذف منابع کشاورزی در فصل خشک و حذف منابع صنعتی و شهری در فصل تر به ترتیب در بالادست و پاییندست شهر اهواز تاثیر زیادی در کاهش شوری رودخانه دارد. نتایج سناریوی کاهش نشان داد، کاهش از مرز بالادست در انتهای محدوده مطالعاتی در فصل تر و خشک به ترتیب با متوسط کاهش 35/10و 26/10درصد شوری رودخانه مؤثر است. نتایج شبیهسازی گزینههای ترکیبی نشان داد که، سناریوی کاهش %52شوری از مرز بالادست همراه کاهش %30از منابع نقطهای در دو فصل تر و خشک به ترتیب با متوسط 60و 46درصد کاهش شوری عملکرد بهتری نسبت به سایر گزینهها در کاهش شوری رودخانه دارد. مقایسه نتایج سناریوهای برتر با حدود مجاز استاندارد شوری آب نشان داد که در هر دو فصل تر و خشک، شرایط حد مجاز آب شرب و کشاورزی قابل تأمین است .",
            URL: "http://ceej.aut.ac.ir/article_1035.html",
            DOI: "10.22060/CEEJ.2017.12160.5138",
            ISSN: "2588-2988",
            language: "fa",
            author: [
              {
                family: "فکوری دکاهی",
                given: "بهمن",
              },
              {
                family: "مظاهری",
                given: "مهدی",
              },
              {
                family: "سامانی",
                given: "جمال  محمدولی",
              },
            ],
            issued: {
              "date-parts": [["1397", 4]],
            },
          },
        ],
      },
      data => {
        console.log(data);
        const citation = (
          <>
            {data.map(ex => (
              <>
                {renderHtml(ex.citation)}
                <br />
              </>
            ))}
          </>
        );
        const bibliography = (
          <>
            {data.map(ex => (
              <>{renderHtml(ex.bibliography)}</>
            ))}
          </>
        );
        const example = (
          <>
            <h3>{title}</h3>
            <lable>درون‌متن:</lable>
            <br />
            {citation}
            <br /> <lable>کتابنامه:</lable>
            {bibliography}{" "}
          </>
        );

        context.modal.content = example;
        context.modal.contentChanged();
      },
      error => {
        console.log(error);
      },
    );
  };
  const Post = ({ post }) => {
    return (
      <div className="list-Item-container csl-list-Item-container w-100">
        <div className="metaData-list-Items">
          <div className="metaData-list-item-content csl-list-Item-title">
            <span className="font-weight-bold">{post.title_fa}</span>
          </div>
          <div className="metaData-list-item-icon csl-list-Item-icon">
            <a
              href={post.file}
              target="_blank"
              className="csl-item-web"
              rel="noopener noreferrer">
              <IoMdDownload className="csl-download-Button" />
            </a>
            <img
              onClick={() => generateExample(post.id, post.title_fa)}
              className="csl-item-web csl-see-icon"
              src="images/getCite.webp"
              width="22px"
              height="25px"
              alt="csl-png"
            />
          </div>
        </div>
      </div>
    );
  };
  useEffect(() => {
    let filtered = csls;

    if (searchCslType) {
      filtered = filtered.filter(csl => csl.type === parseInt(searchCslType));
    }

    if (searchSource) {
      searchSource === "1998"
        ? (filtered = filtered.filter(csl => csl.default.toString() === "2"))
        : (filtered = filtered.filter(
            csl => csl.source.id.toString() === searchSource,
          ));
    }

    if (searchTerm) {
      const searchTermLower = searchTerm.toLowerCase();
      filtered = filtered.filter(csl =>
        csl.title_fa.toLowerCase().includes(searchTermLower),
      );
    }

    setFilteredCsls(filtered);
    setCurrentPage(1);
  }, [csls, searchTerm, searchSource, searchCslType]);

  const getBaseCsls = () => {
    const storedBaseCsls = sessionStorage.getItem("allBaseCsls");

    if (storedBaseCsls) {
      set_base_csl(JSON.parse(storedBaseCsls));
    } else {
      context.ApiDriver.getBaseCsls(
        { slugs: ["base_csls"] },
        data => {
          set_base_csl(data.data[0].value);
          sessionStorage.setItem(
            "allBaseCsls",
            JSON.stringify(data.data[0].value),
          );
        },
        error => {
          console.log(error);
        },
      );
    }
  };

  const getSources = () => {
    const storedSources = sessionStorage.getItem("allSources");

    if (storedSources) {
      setSources(JSON.parse(storedSources));
    } else {
      context.ApiDriver.getSources(
        { page_size: 1000 },
        data => {
          setSources(data.data);
          sessionStorage.setItem("allSources", JSON.stringify(data.data));
        },
        error => {
          console.log(error);
        },
      );
    }
  };
  const getCsls = () => {
    setLoadingState(Statics.LOADING);
    const storedCsls = sessionStorage.getItem("allCsls");

    if (storedCsls) {
      setCsls(JSON.parse(storedCsls));
      setLoadingState(Statics.LOADED);
    } else {
      context.ApiDriver.getCsls(
        { page_size: 1000 },
        data => {
          setCsls(data.data);
          sessionStorage.setItem("allCsls", JSON.stringify(data.data));
          setLoadingState(Statics.LOADED);
        },
        error => {
          console.log(error);
          setLoadingState(Statics.CAUSED_ERROR);
        },
      );
    }
  };
  useEffect(() => {
    if (loadingState === Statics.NOT_LOADED) {
      getCsls();
      getSources();
      getBaseCsls();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <DocumentMeta {...page_meta}>
      <section className="hero-sample">
        <div className="hero-sample-right">
          <h1>شیوه‌نامه استنادی در پژوهیار</h1>
          <p>
            امکانی را فراهم ‌می‌کند که شیوه‌نامه‌های مصوب نشریه‌ها و دانشگاه‌ها
            به صورت آسان و سریع از طریق پژوهیار در دسترس کاربران قرار می‌گیرد.
          </p>
        </div>
        <div className="hero-sample-left">
          <img src={Shive} alt="downloadImg" className="" />
        </div>
      </section>

      <Container className="d-flex flex-column justify-content-center overflow-hidden py-4 text-right">
        <Tabs
          defaultActiveKey={selectedTab}
          className="d-flex justify-content-center w-100 custom-tab-content flex-nowrap justify-content-center mb-5 csl-tab-content">
          <Tab
            eventKey="csl-list"
            tabClassName="d-flex align-items-center flex-1"
            title={<span className="addon-tabs">شیوه‌نامه‌ها</span>}>
            {loadingState === Statics.CAUSED_ERROR ? (
              <div className="error-parent mt-5">
                <p>ارتباط با سرور با مشکل مواجه شد !</p>
                <img
                  className="error-img"
                  src="images/errorPic.webp"
                  width="200px"
                  alt="error-png"
                />
              </div>
            ) : null}
            {loadingState === Statics.LOADED ? (
              <div className="my-3">
                <Row className="px-2 py-3 metaData-controls  csl-controls py-md-2 w-100 mx-0">
                  <Col
                    md={3}
                    sm={12}
                    className="d-flex justify-content-center align-items-center">
                    نوع:
                    <Form.Group className="w-100 m-0 mb-2 mb-md-0">
                      <Form.Control
                        as="select"
                        value={searchCslType}
                        onChange={e => setSearchCslType(e.target.value)}>
                        <option value="">همه</option>
                        <option value="2">عددی</option>
                        <option value="3">نویسنده</option>
                        <option value="4">نویسنده - تاریخ</option>
                        <option value="5">پانویس</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>

                  <Col
                    sm={12}
                    md={3}
                    className="d-flex justify-content-center align-items-center">
                    مرجع:
                    <Form.Group className="w-100 m-0 mb-2 mb-md-0">
                      <Form.Control
                        as="select"
                        value={searchSource}
                        onChange={e => setSearchSource(e.target.value)}>
                        <option value="">همه</option>
                        <option value="1998">شیوه‌نامه‌های برتر</option>
                        {sources.map(s => (
                          <option key={s.id} value={s.id}>
                            {s.title}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>

                  <Col sm={12} md={6} className="d-flex justify-content-center">
                    <Form.Group className="w-100 m-0 mb-2 mb-md-0">
                      <FormControl
                        placeholder="جستجوی شیوه‌نامه..."
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            ) : null}

            <div>
              {loadingState === Statics.LOADING ? (
                <div className="pajoohyar-loading">
                  <Loading />
                </div>
              ) : null}

              {loadingState === Statics.LOADED && (
                <>
                  <div className="justify-content-center text-center mataData-list d-flex flex-column   w-100">
                    {filteredCsls
                      .slice(
                        (currentPage - 1) * pageSize,
                        currentPage * pageSize,
                      )
                      .map(csl => (
                        <Post key={csl.id} post={csl} />
                      ))}
                  </div>
                  {filteredCsls.length === 0 && (
                    <div className="text-center py-4">
                      <h4>موردی یافت نشد</h4>
                    </div>
                  )}

                  {filteredCsls.length > pageSize && (
                    <div className="d-flex justify-content-center csl-pagination p-4">
                      <Pagination
                        currentPage={currentPage}
                        totalCount={filteredCsls.length}
                        pageSize={pageSize}
                        onPageChange={setCurrentPage}
                      />
                    </div>
                  )}
                </>
              )}
            </div>
          </Tab>

          <Tab
            eventKey="csl-order"
            tabClassName="d-flex align-items-center flex-1"
            title={<span className="addon-tabs">سفارش شیوه‌نامه</span>}>
            <div className="mx-0 form-container csl-order-form">
              <div className="">
                <>
                  <Row className="mx-0">
                    <Col
                      md={4}
                      className={`form-floating ${
                        errors.name && "invalid-input2"
                      } `}>
                      <FormControl
                        id="fullname"
                        className={`form-control-lg rounded-3 ${
                          errors.name && "is-invalid"
                        }`}
                        placeholder=" "
                        onChange={e => {
                          set_form_name(e.target.value);
                        }}
                      />
                      <label className="text-secondary">
                        نام و نام خانوادگی
                      </label>
                      {errors.name && (
                        <div className="invalid-feedback d-block">
                          {errors.name}
                        </div>
                      )}
                    </Col>
                    <Col
                      md={4}
                      className={`form-floating ${
                        errors.email && "invalid-input2"
                      } `}>
                      <FormControl
                        id="email"
                        className={`form-control-lg rounded-3 ${
                          errors.email && "is-invalid"
                        }`}
                        placeholder=" "
                        onChange={e => {
                          set_form_email(e.target.value);
                        }}
                      />
                      <label className="text-secondary">آدرس ایمیل</label>
                      {errors.email && (
                        <div className="invalid-feedback d-block">
                          {errors.email}
                        </div>
                      )}
                    </Col>
                    <Col
                      md={4}
                      className={`form-floating ${
                        errors.phone && "invalid-input2"
                      } `}>
                      <FormControl
                        id="phone"
                        className={`form-control-lg rounded-3 ${
                          errors.phone && "is-invalid"
                        }`}
                        placeholder=" "
                        onChange={e => {
                          set_form_phone(e.target.value);
                        }}
                      />
                      <label className="text-secondary">شماره تماس</label>
                      {errors.phone && (
                        <div className="invalid-feedback d-block">
                          {errors.phone}
                        </div>
                      )}
                    </Col>
                  </Row>
                  <Row className="mx-0">
                    <Col md={8} className="form-floating mt-3">
                      <FormControl
                        id="head_fullname"
                        className="form-control-lg rounded-3"
                        placeholder=" "
                        onChange={e => {
                          set_form_head(e.target.value);
                        }}
                      />
                      <label className="text-secondary">
                        نام و نام خانوادگی سرپرست
                      </label>
                    </Col>
                    <Col md={4} className="form-floating mt-3">
                      <FormControl
                        id="head_phone"
                        className="form-control-lg rounded-3"
                        placeholder=" "
                        onChange={e => {
                          set_form_headphone(e.target.value);
                        }}
                      />
                      <label className="text-secondary">
                        شماره تماس سرپرست
                      </label>
                    </Col>
                  </Row>
                  <Row className="mx-0">
                    <Col className="form-floating mt-3">
                      <FormControl
                        id="organization"
                        className="form-control-lg rounded-3"
                        placeholder=" "
                        onChange={e => {
                          set_form_organization(e.target.value);
                        }}
                      />
                      <label className="text-secondary">
                        نام سازمان/مجله/کنفرانس/دانشگاه
                      </label>
                    </Col>
                  </Row>
                  <Row className="mx-0">
                    <Col md={4} className="form-floating mt-3">
                      <FormControl
                        id="faculty"
                        className="form-control-lg rounded-3"
                        placeholder=" "
                        onChange={e => {
                          set_form_faculty(e.target.value);
                        }}
                      />
                      <label className="text-secondary">نام پایگاه</label>
                    </Col>
                    <Col md={4} className="form-floating mt-3">
                      <FormControl
                        id="website"
                        className="form-control-lg rounded-3"
                        placeholder=" "
                        onChange={e => {
                          set_form_website(e.target.value);
                        }}
                      />
                      <label className="text-secondary">آدرس پایگاه</label>
                    </Col>
                    <Col md={4} className="file-upload-wrapper mt-3">
                      <label htmlFor="file" className="custom-file-upload">
                        <i className="fas fa-cloud-upload-alt me-2"></i>
                        {form_file ? form_file.name : "انتخاب فایل"}
                      </label>
                      <Form.Control
                        id="file"
                        className="d-none"
                        type="file"
                        onChange={e => {
                          set_form_file(e.target.files[0]);
                        }}
                      />
                    </Col>
                  </Row>
                  <Row className="mx-0">
                    <Col className="form-floating form-floating-des mt-3">
                      <Form.Group>
                        <Form.Control
                          id="description"
                          className="form-control-lg rounded-3"
                          as="textarea"
                          rows="3"
                          onChange={e => {
                            set_form_description(e.target.value);
                          }}
                          placeholder=" "
                        />
                        <label className="text-secondary">توضیحات تکمیلی</label>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>انتخاب یکی از شیوه‌ها</Form.Label>
                        <Form.Control
                          required
                          as="select"
                          onChange={e => {
                            set_base(e.target.value);
                          }}>
                          {base_csl.map(csl => (
                            <option key={csl.key} value={csl.key}>
                              {csl.value}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Text className="text-muted">
                          در صورتی که شیوه‌نامه شما به یکی از شیوه‌نامه های اصلی
                          شباهت دارد ، لطفا آن را انتخاب کنید.
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="justify-content-end">
                    <Col md={4}>
                      <Button
                        variant="primary"
                        className="w-100 py-2 rounded-pill fw-bold"
                        disabled={send_order}
                        onClick={SendOrder}>
                        {send_order ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            در حال ارسال...
                          </>
                        ) : (
                          <>ثبت سفارش</>
                        )}
                      </Button>
                    </Col>
                  </Row>
                </>
              </div>
            </div>
          </Tab>
        </Tabs>
        <Modal className="csl-modal" />
      </Container>
    </DocumentMeta>
  );
};

export default Csl;
